module.exports = __webpack_public_path__ + "img/logo.ebb52346.png";